import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-inline-help-content',
    templateUrl: './inline-help-content.component.html',
    styleUrls: ['./inline-help-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InlineHelpContentComponent implements OnInit {
  message;

  constructor() {}

  ngOnInit(): void {}
}
